import React from 'react'

class WorkingHour extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <g transform="translate(1 1)" fillRule="nonzero" fill="none">
          <circle stroke="#1B66B3" strokeWidth="2" cx="7.5" cy="7.5" r="7.5" />
          <path fill="#1B66B3" d="M6.5 3h1.8v5.5H6.5z" />
          <path fill="#1B66B3" d="M12 6.8v1.8H6.5V6.8z" />
        </g>
      </svg>
    )
  }
}

export default WorkingHour
